<template>
    <div style="display:none" id="body">
        <div class="background" id="background">
        </div>
        <div style="position:fixed;z-index:96;left:0;" align="center">
            <button class="css_btn_class" id="button" center @click="toDownload">
                下载APP
            </button>
        </div>
        <div class="fonts" id="fonts" align="center">
            <font size="5" color="white" face="Microsoft YaHei" class="title">掌上法云</font>
        </div>
        <div class="imgDivPhone" id="imgDivPhone" align="center">
            <img src="../../../static/images/phone.png" class="coverImgPhone" @click="yc"
                 style="display:block" center
                 id="phoneImg">
            </img>
        </div>
        <div class="cover" id="cover">
            <img src="../../../static/images/cover.png" id="coverImg">
            </img>
        </div>
        <div style="position:fixed;z-index:96;bottom:20px;color:#ffe8e8;font-size:0.8em;line-height:20px">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;由苏州德启智能科技有限公司研发，基于云系列产品的管理软件，致力于云柜终端硬件的优化和成本控制、云系列平台的开发，通过积极推动云柜、中间柜等产品的普遍应用，最终提供高效材料案件的存储与转发解决方案。
        </div>
        <div class="imgDiv" id="imgDiv" @click="yc" style="display:none">
            <img src="../../../static/images/guide.png" class="guideImg" id="tp" style="display:block">
            </img>
        </div>
    </div>
</template>

<script>
	export default {
		name: "shareDownload",
		mounted() {
			this.init();
		},
		methods: {
			yc() {
				document.getElementById('imgDiv').style.display = 'none';
			},
			toDownload() {
				var u = navigator.userAgent, app = navigator.appVersion;
				var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
				var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
				if (isAndroid) {
					//这个是安卓操作系统
					window.location.href = 'http://dqist-app-install.oss-cn-hangzhou.aliyuncs.com/app/v1.1.1/PocketLawCloud.apk'
				}
				if (isIOS) {
					window.location.href = 'https://itunes.apple.com/cn/app/%E6%8E%8C%E4%B8%8A%E6%B3%95%E4%BA%91/id1434524018?mt=8'
				}
			},
			init() {
				let self = this;
				setTimeout(() => {
					document.getElementById("body").style.display = "block";
					var flag = self.isWeiXin()
					var url = location.search
					var height = document.body.scrollHeight < document.documentElement.scrollHeight ? document.documentElement.scrollHeight : document.body.scrollHeight;
					var width = document.documentElement.scrollWidth
					var imgHeight = document.images[1].height
					if (imgHeight / height > 0.7) {
						imgHeight = height * 0.7
						document.getElementById("phoneImg").style.height = imgHeight + 'px'
						document.getElementById("phoneImg").style.width = 'auto'
					}
					// 设置覆盖图片div高度
					document.getElementById("background").style.height = height + 'px'
					document.getElementById("imgDiv").style.height = height + 'px'
					document.getElementById("cover").style.height = height / 2 + 'px'
					// 设置宽度
					document.getElementById("background").style.width = width + 'px'
					document.getElementById("imgDiv").style.width = width + 'px'
					document.getElementById("cover").style.width = width + 'px'
					// 设置图片宽度高度
					document.getElementById("coverImg").style.width = width + 'px'
					document.getElementById("coverImg").style.height = height / 2 + 'px'
					// 设置手机图片位置居中
					document.getElementById("imgDivPhone").style.top = (height - imgHeight) / 2 + 'px'
					// 设置标题位置
					document.getElementById("fonts").style.top = (height - imgHeight) / 4 + 'px'
					// 设置按钮位置 200为按钮宽度
					if (width > 200) {
						document.getElementById("button").style.left = (width - 200) / 2 + 'px'
					} else {
						document.getElementById("button").style.width = width + 'px'
					}
					document.getElementById("button").style.top = (0.68 * height) + 'px'
					if (flag) {
						document.getElementById('imgDiv').style.display = 'block';
					}
					self.doOpen()
				}, 100);
			},
			openApp(src) {
				// 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
				// 否则打开a标签的href链接
				var ifr = document.createElement('iframe');
				ifr.src = src;
				ifr.style.display = 'none';
				document.getElementById("body").appendChild(ifr);
				window.setTimeout(function () {
					document.getElementById("body").removeChild(ifr);
				}, 2000);
			},
			//判断是否是微信浏览器的函数
			isWeiXin() {
				//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
				var ua = window.navigator.userAgent.toLowerCase();
				//通过正则表达式匹配ua中是否含有MicroMessenger字符串
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			},
			//判断是否为不可打开app的浏览器
			doOpen() {
				var ua = window.navigator.userAgent.toLowerCase();
				//通过正则表达式匹配ua中是否含有MicroMessenger字符串
				if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/MiuiBrowser/ig) == 'miuibrowser' || ua.match(/UcBrowser/i) == 'ucbrowser' || ua.match(/BaiduBrowser/i) == 'baidubrowser') {
					alert("该浏览器不支持跳转app，请手动打开掌上法云，使用扫一扫功能进行扫描")
				}
			}
		}
	}
</script>

<style scoped>
    #body {
        margin: 0px;
        padding: 0px;
    }

    .title {
        position: relative;
    }

    .guideImg {
        width: 100%;
        height: auto;
        position: fixed;
        z-index: 99;
    }

    .coverImgPhone {
        width: 60%;
        height: auto;
        /* position: fixed; */
        z-index: 50;
    }

    .background {
        position: fixed;
        background: url(../../../static/images/bg.png);
        background-size: cover;
        text-align: center;
        z-index: 0;
        top: 0;
        left: 0;
        /* height: 100%;
        width: 100%; */
    }

    .css_btn_class {
        position: relative;
        -moz-box-shadow: inset 0px 0px 0px 0px #ffffff;
        -webkit-box-shadow: inset 0px 0px 0px 0px #ffffff;
        box-shadow: inset 0px 0px 0px 0px #ffffff;
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0.05, #ffffff), color-stop(1, #ffffff));
        background: -moz-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: -webkit-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: -o-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: -ms-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: linear-gradient(to bottom, #ffffff 5%, #ffffff 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#ffffff', GradientType=0);
        background-color: #ffffff;
        -moz-border-radius: 6px;
        -webkit-border-radius: 6px;
        border-radius: 6px;
        border: 1px solid #ffffff;
        display: inline-block;
        cursor: pointer;
        color: #74a7ff;
        font-family: Arial;
        font-size: 20px;
        font-weight: normal;
        padding: 1px 10px;
        text-decoration: none;
        text-shadow: 0px 1px 0px #ffffff;
        top: 401px;
        z-index: 96;
        width: 200px;
        height: 50px;
    }

    .css_btn_class:hover {
        position: relative;
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0.05, #ffffff), color-stop(1, #ffffff));
        background: -moz-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: -webkit-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: -o-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: -ms-linear-gradient(top, #ffffff 5%, #ffffff 100%);
        background: linear-gradient(to bottom, #ffffff 5%, #ffffff 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#ffffff', GradientType=0);
        background-color: #ffffff;
        z-index: 96
    }

    .css_btn_class:active {
        position: relative;
        top: 401px;
        z-index: 96
    }

    .imgDiv {
        position: relative;
        z-index: 99;
        width: 100%;
        height: auto;
        background-color: #000000;
        opacity: 0.8;
        top: 0;
        left: 0;
    }

    .cover {
        position: fixed;
        z-index: 95;
        width: 100%;
        opacity: 0.8;
        bottom: 0;
        left: 0;
    }

    .imgDivPhone {
        position: fixed;
        width: 100%;
        height: auto;
        z-index: 90;
        top: 0;
        left: 0;
    }

    .fonts {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
    }

    .fixedWrapper {
        width: 100%;
        overflow: hidden;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/view/share/download.vue